import Accordion from 'react-bootstrap/Accordion';
import SportCode from 'components/common/SportCode'
import VvoPlayerStatsScore from './VvoPlayerStatsScore';
import VvoPlayerStatsNonScore from './VvoPlayerStatsNonScore';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const getPeriodOrder = (periodsOrder, period) => {
    return periodsOrder?.find(i => i.period === period)?.order;
}

const RenderPeriods = ({ data, periods, periodsOrder, isScore }) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    periods?.sort((a, b) => getPeriodOrder(periodsOrder, b.p_code) - getPeriodOrder(periodsOrder, a.p_code));
    return periods?.map(item => {
        let currPeriod = item.p_code
        return (
            <Accordion.Item id={`mirs-accordion-item-${item.p_code}`} eventKey={item.p_code} key={item.p_code}>
                <Accordion.Header><SportCode discipline={mirs_discipline} entity='@Period' code={item.p_code} /></Accordion.Header>
                <Accordion.Body>
                    {isScore
                        ? <><VvoPlayerStatsScore data={data} team={1} currPeriod={currPeriod} periods={periods} />
                            <VvoPlayerStatsScore data={data} team={2} currPeriod={currPeriod} periods={periods} /></>
                        : <><VvoPlayerStatsNonScore data={data} team={1} currPeriod={currPeriod} periods={periods} />
                            <VvoPlayerStatsNonScore data={data} team={2} currPeriod={currPeriod} periods={periods} /></>
                    }
                </Accordion.Body>
            </Accordion.Item>
        )
    }
    )
}

function VvoPlayerStats({ data, periodsOrder, isScore }) {
    let periods = data?.results?.periods
    return (
        <Accordion defaultActiveKey={periods[0].p_code}>
            <RenderPeriods data={data} periods={periods} periodsOrder={periodsOrder} isScore={isScore} />
        </Accordion>
    );
}

export default VvoPlayerStats;